import {createLogger, isEqual, getHostInfo} from '@servicenow/ui-internal';

const log = createLogger();

export function updateStateEffect(reducerFn = s => s, coeffects) {
	const {state, action, updateProperties, updateState, host} = coeffects;
	const updatedState = reducerFn(state, action);

	const {tagName, componentId} = getHostInfo(host);
	log('createUpdateStateEffect has been deprecated. Please use updateState helper instead.', {
		tagName,
		componentId,
		host,
		origin: 'updateStateEffect'
	});

	// LEGACY: support legacy components that are spreading properties across state
	if (!isEqual(updatedState.properties, state.properties)) {
		updateProperties(updatedState.properties);
		log(
			'Spreading properties across state in a createUpdateStateEffect is no longer supported. Please use the updateProperties helper.',
			{host, origin: 'updateStateEffect'}
		);
	}

	updateState(updatedState, {
		SCHEDULE_IMMEDIATELY_DO_NOT_USE_OR_YOU_WILL_BE_IMMEDIATELY_FIRED: true
	});
}

/**
 * **This package is deprecated. Please read about the new helper `updateState` in the state and helpers pages under Main Concepts**
 *
 * Effect that updates the UI Framework data store. Data is stored under the context of the dispatching action that triggered the effect.
 *
 * **Note**: If possible, use the updateState helper function that supports declarative state updates instead.
 *
 * @function createUpdateStateEffect
 * @example
 * import {createUpdateStateEffect} from '@servicenow/ui-effect-update-state';
 *
 * const addActionPayloadToStateEffect = createUpdateStateEffect(
 *   (state, action) => ({...state, ...action.payload})
 * );
 *
 * // Register with component action handlers:
 * {
 *   actionHandlers: {
 *     'SOMETHING_HAPPENED': addActionPayloadToStateEffect
 *   }
 * }
 *
 * @param {Function} reducerFn - Function that reduces current state to new state: (currentState, action) => newState
 * @return {Object} Update State Effect Descriptor
 */
export default function createUpdateStateEffect(reducerFn) {
	return {
		effect: updateStateEffect,
		args: [reducerFn]
	};
}
